jQuery(document).ready(function($) {
  // Existing code: Attach a click event to the rows with the class 'has-sales-orders'
  $('tr.has-sales-orders').on('click', function() {
    // Get the id of the clicked row
    var parentId = $(this).attr('id');

    // Extract the document number from the parent id (e.g., "MD446872" from "parent-sales-orders-MD446872")
    var idSuffix = parentId.replace('parent-sales-orders-', '');

    // Construct the child row identifiers using the document number
    var childId = 'child-sales-orders-' + idSuffix;
    var childClassb = 'child-sales-orders-payments-' + idSuffix;

    // Toggle invoice items row (by id) and all payment/credit memo rows (by class)
    $('#' + childId).toggle();
    $('.' + childClassb).toggle();
  });

  // New code: Attach a change event to the select element with id 'dateFilter'
  $('#dateFilter').on('change', function() {
    // Get the selected value
    var selectedValue = $(this).val();

    // If a value is selected, reload the page with the filter_date query parameter
    if (selectedValue) {
      var url = new URL(window.location.href);
      url.searchParams.set('filter_date', selectedValue);
      window.location.href = url.toString();
    }
  });

  // Add to cart (Reorder)
  $('.add-to-cart-button').on('click', function(e) {
    e.preventDefault();

    // Disable the button to prevent multiple clicks
    var $button = $(this);
    $button.prop('disabled', true);
    $button.text('Redirecting...');

    // Get variation IDs and quantity from the button's data attributes
    var variationIds = $button.data('variation-ids');
    var quantity = 1;

    $.ajax({
      url: Drupal.url('order-history/add-to-cart'),
      type: 'GET',
      data: {
        variation_ids: variationIds,
        quantity: quantity
      },
      success: function(response) {
        if (response.status === 'success') {
          // Redirect to the cart page on success.
          window.location.href = Drupal.url('cart');
        } else {
          // Re-enable the button if there was an error
          $button.prop('disabled', false);
          $button.text('Reorder Products');
          alert('An error occurred while adding products to the cart.');
        }
      },
      error: function() {
        // Re-enable the button if there was an error
        $button.prop('disabled', false);
        $button.text('Reorder Products');
        alert('An error occurred. Please try again.');
      }
    });
  });
});
